<template>
  <span>
    <el-upload
      ref="upload"
      :disabled="(!multiple && fileList.length > 0) || disabled"
      :action="action"
      :show-file-list="false"
      :multiple="multiple"
      :http-request="UploadFile"
      :before-upload="onBeforeUploadFile"
      :on-change="onChange"
    >
      <!-- 添加按钮 -->
      <el-button
        v-if="fileList.length < 1"
        icon="el-icon-plus"
        :loading="uploadLoading"
        >{{ '添加' + btnName }}{{ required ? ' *' : '' }}</el-button
      >
      <!-- 多选 -->
      <el-button
        v-else-if="multiple"
        type="primary"
        icon="el-icon-plus"
        :loading="uploadLoading"
        >{{ '添加' + btnName }}</el-button
      >
      <!-- 单选 -->
      <el-button
        v-else
        style="position: relative"
        type="primary"
        :icon="fileList.length < 1 ? 'el-icon-plus' : ''"
        :loading="uploadLoading"
      >
        <el-popover
          placement="top-start"
          trigger="hover"
          popper-class="popper--upload-class"
          :disabled="popoverDisabled"
        >
          <div>
            <span v-if="!disabled">
              <el-button
                type="text"
                icon="el-icon-view"
                @click="previewBtn(fileList[0])"
                >预览</el-button
              >
              <el-button
                type="text"
                icon="el-icon-download"
                @click="downloadFile(fileList[0])"
                >下载</el-button
              >
            </span>
            <span v-else class="disabled-popover">
              <span @click="previewBtn(fileList[0])"
                ><i class="el-icon-view"></i>预览</span
              >
              <span @click="downloadFile(fileList[0])"
                ><i class="el-icon-download"></i>下载</span
              >
            </span>
          </div>
          <p slot="reference">
            <i class="el-icon-document"></i>
            {{ btnName }}
            <i
              v-if="!disabled"
              class="el-icon-close close-icon"
              @click.stop="singleDelete"
            ></i>
          </p>
        </el-popover>
      </el-button>
      <!-- 提示语 -->
      <p
        class="upload-tips-text"
        v-if="showTips"
        >{{ showTips }}
      </p>
    </el-upload>

    <!-- 多文件 -->
    <div v-if="multiple">
      <span v-for="(item, index) in fileList" :key="index" class="fileItem">
        <el-popover
          placement="top-start"
          trigger="hover"
          popper-class="popper--upload-class"
          :disabled="popoverDisabled"
        >
          <div>
            <span v-if="!disabled">
              <el-button
                type="text"
                icon="el-icon-view"
                @click="previewBtn(item)"
                >预览</el-button
              >
              <el-button
                type="text"
                icon="el-icon-download"
                @click="downloadFile(item)"
                >下载</el-button
              >
            </span>
            <span v-else class="disabled-popover">
              <span @click="previewBtn(item)"
                ><i class="el-icon-view"></i>预览</span
              >
              <span @click="downloadFile(item)"
                ><i class="el-icon-download"></i>下载</span
              >
            </span>
          </div>
          <p slot="reference">
            <i class="el-icon-document"></i>
            {{ item.fileName }}
            <i
              v-if="!disabled"
              class="el-icon-close mul-icon-close"
              @click.stop="deleteBtn(index)"
            ></i>
          </p>
        </el-popover>
      </span>
    </div>

    <!-- 预览文件 -->
    <previewFileDialog :type="fileType" :url="fileUrl" ref="previewDialog" :disabled="disabled" />
    <!-- 图片预览 -->
    <el-image-viewer
      style="z-index: 999999"
      v-if="dialogVisible"
      :on-close="()=> {this.dialogVisible = false}"
      :url-list="[dialogImageUrl]"
    />
  </span>
</template>
<script>
import upload from '@/utils/upload';
import download from '@/utils/download';
import previewFileDialog from '@/components/previewFileDialog';
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'

export default {
  components: { previewFileDialog, ElImageViewer },
  props: {
    multiple: {
      type: Boolean,
      default: true,
    },
    btnName: {
      type: String,
      default: '',
    },
    field: {
      type: String,
      default: '',
    },
    showTips: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    maxSize: {
      type: Number,
      default: 100,
    },
    excelFileExtend: {
      type: String,
      default: '.xls,.xlsx,.csv',
    },
    required: {
      type: Boolean,
      default: false,
    },
    url: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'file',
    },
  },
  data() {
    return {
      action: '',
      uploadLoading: false,
      fileList: [],
      fileType: '',
      fileUrl: '',
      num: 0,
      currentFileList: [],
      popoverDisabled: false,
      dialogVisible: false,
      dialogImageUrl: ''
    };
  },
  watch: {
    uploadLoading(val) {
      if(!val) {
        this.num = 0;
        this.currentFileList = [];
      }
    }
  },
  methods: {
    // 检验文件
    onBeforeUploadFile(file) {
      const excelFileExtend = this.excelFileExtend; //设置文件格式
      const fileExtend = file.name
        .substring(file.name.lastIndexOf('.'))
        .toLowerCase();
      let isFile;
      if (this.excelFileExtend !== 'all') {
        isFile = excelFileExtend.indexOf(fileExtend) > -1;
        if (!isFile) {
          this.$message.error('文件格式错误!');
          return false;
        }
      } else {
        isFile = true;
      }
      const isLt2M = file.size / 1024 / 1024 < this.maxSize;
      if (!isLt2M) {
        this.$message.error(`上传附件大小不能超过 ${this.maxSize}MB!`);
        return false;
      }
      this.uploadLoading = true;
      return isFile && isLt2M;
    },
    // 上传文件
    async UploadFile(param) {
      this.num++;
      const { success, name, src, err } = await upload(
        process.env.VUE_APP_CML_BASE_URL + 'file/uploadPrivate',
        param.file,
      );

      if (success !== '1' || err) {
        this.$message.error(err.msg);
        this.fileList = [];
        this.uploadLoading = false;
        return;
      }
      if (this.multiple) {
        this.fileList.push({ fileName: name, fileUrl: src });
        this.currentFileList.push({ fileName: name, fileUrl: src });
        if (this.currentFileList.length === this.num) {
          this.uploadLoading = false;
        }
      } else {
        this.uploadLoading = false;
        this.fileList = [{ fileName: name, fileUrl: src }];
        this.currentFileList = [{ fileName: name, fileUrl: src }];
      }
    },
    deleteBtn(index) {
      this.fileList.splice(index, 1);
      this.$emit('file-list-change', this.fileList);
    },
    singleDelete() {
      this.fileList = [];
      this.$emit('file-list-change', this.fileList);
    },
    // 下载模板文件
    downloadFile({ fileUrl, fileName }) {
      download(fileUrl, fileName);
    },
    // 预览文件
    previewBtn({ fileName, fileUrl }) {
      // 隐藏popover弹窗
      this.popoverDisabled = true;
      setTimeout(() => {
        this.popoverDisabled = false;
      }, 500);
      const fileExtend = fileName.substring(fileName.lastIndexOf('.')).toLowerCase();
      this.fileUrl = fileUrl;
      const Ex = ['jpg','png','jpeg','pdf']
      const type = Ex.find(item => fileExtend.indexOf(item) > -1)
      this.fileType = type ? type : 'file'
      // this.fileType = fileExtend.indexOf('pdf') > -1 ? 'pdf' : 'file';
      this.fileType === "pdf" || this.fileType === "file" ? this.$refs.previewDialog.dialogVisible = true : this.open(fileUrl)
    },
    onChange() {
      this.$emit('file-list-change', this.fileList);
    },
    open(url) {
      // // 判断是否是私密文件
      const isPrivateFile = url.split(':');
      if(isPrivateFile.length === 1 && isPrivateFile[0] !== 'https') {
        // 私密文件，获取带有过期时间的完整路径
        this.$http.setting
          .getSignedUrl(encodeURIComponent(url))
          .then(result => {
            this.dialogVisible = true
            this.dialogImageUrl = `${result.data}&r=${Date.now()}`
          })
          .catch(err => {
            this.$message.error(err.msg);
          });
      } else {
        // 未加密文件
        this.dialogVisible = true
        this.dialogImageUrl = `${this.url}?r=${Date.now()}`
      }
    },
  },
};
</script>

<style lang="less" scoped>
/deep/ .el-upload {
  text-align: left;
}
/deep/ .el-upload-list__item {
  width: 300px;
}
.file {
  color: #fff;
}
.fileItem {
  position: relative;
  display: block;
  text-align: left;
  color: #606266;
  margin-top: 5px;
  padding-right: 10px;
  cursor: pointer;
  max-width: 300px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin: 5px 0;
  &:hover {
    background: #eee;
    color: #AB0033;
  }
}
/deep/ .close-icon {
  position: absolute;
  top: -5px;
  right: -5px;
  z-index: 1000;
  border-radius: 50%;
  font-size: 18px;
  background: #ccc;
}
/deep/ .mul-icon-close {
  position: absolute;
  top: 5px;
  right: -2px;
  z-index: 1000;
  font-size: 18px;
  color: #AB0033;
}
.el-popover__reference {
  display: block;
  width: 100% !important;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.disabled-popover {
  span {
    margin: 0 20px;
    font-size: 14px;
    color: #AB0033;
    cursor: pointer;
    i {
      margin: 0 5px;
    }
    &:hover {
      text-decoration: underline;
    }
  }
}
/deep/ .el-upload {
  position: relative;
}
.upload-tips-text {
  position: absolute;
  left: 102%;
  top: 6px;
  font-size: 12px;
  line-height: 16px;
  color: #AB0033;
  width: 300px;
}
</style>